import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import cn from 'classnames';
import { toastr } from 'react-redux-toastr';
import styles from './RegisterInstrumentModal.module.scss';
import Modal from '../../components/Shared/Modal/Modal';
import { Button, LargeButton } from '../../components/Shared/Buttons';
import { InputItem, InputRow } from '../../components/Shared/Forms/';
import ChangeDeviceName from './ChangeDeviceName';
import idxImage from './Images/idx.png';
import beaconImage from './Images/beacon.png';
import megaISQImage from './Images/megaISQ.png';
import installGateway from './Images/installGateway.png';
import beaconCode from '../../shared/videos/beaconCode.mp4';
import idxSerialNumber from './Images/idxSerialNumber.png';
import beaconSerialNumber from './Images/beaconSerialNumber.png';
import * as instrumentActions from '../../redux/actions/instrumentActions';
import * as clinicActions from '../../redux/actions/clinicActions';
import * as promotionActions from '../../redux/actions/promotionActions';
import * as userActions from '../../redux/actions/userActions';
import * as generalActions from '../../redux/actions/generalActions';
import * as firmwareActions from '../../redux/actions/firmwareActions';
import * as accountActions from '../../redux/actions/accountActions';
import { toastrOptions } from '../../constants/toastrOptions';

import {
  windowsIcon,
  macIcon,
  connectKeyIllustration,
  connectionSymbol,
  idxCode,
} from './registerIllustrations';

class RegisterInstrumentModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      serialNumber: '',
      registrationCode: '',
      instrumentName: '',
      puk: '',
      instrumentId: '',
      getFreeSmartPegs: false,
      canProceed: true,
      selectedInstrument: undefined,
      currentStepCount: 0,
      currentStep: null,
      currentRegisterStepCount: 0,
      maxSteps: 0,
      currentStepList: [],
      downLoadingFirmwareType: null,
    };
    this.intl = props.intl;

    this.vidRef = React.createRef();

    this.downloadingFirmware = false;
    this.firmwareDownloaded = false;

    this.deviceNames = {
      Beacon: 'Osstell Beacon',
      MegaISQ: 'MEGA ISQ II',
      IDx: 'Osstell IDX',
    };
    this.stepList = {
      Beacon: ['select', 'download', 'install', 'connect', 'serial', 'registrationCode', 'naming'],
      MegaISQ: ['select', 'download', 'install', 'connect', 'serial', 'registrationCode', 'naming'],
      IDx: ['select', 'serial', 'registrationCode', 'puk', 'naming'],
      BeaconApp: ['select', 'pendingInstrument', 'naming'],
    };
    this.formValidation = {
      Beacon: { serial: 6, regCode: 4 },
      MegaISQ: { serial: 6, regCode: 4 },
      IDx: { serial: 5, regCode: 4 },
    };

    this.registerSteps = {
      select: {
        action: () => this.incrementStep(),
        disabled: () =>
          !this.state.selectedInstrument || this.props.registerInstrument.busy || this.props.demo,
        buttonLabel: this.intl.formatMessage({ id: 'general.next', defaultMessage: 'Next' }),
        buttonIcon: 'forward',
        isStep: false,
      },
      download: {
        action: () => this.incrementStep(),
        disabled: () => !this.state.selectedInstrument || !this.firmwareDownloaded,
        buttonLabel: this.intl.formatMessage({ id: 'general.next', defaultMessage: 'Next' }),
        buttonIcon: 'forward',
        isStep: true,
      },
      install: {
        action: () => this.incrementStep(),
        disabled: () => !this.state.selectedInstrument,
        buttonLabel: this.intl.formatMessage({ id: 'general.next', defaultMessage: 'Next' }),
        buttonIcon: 'forward',
        isStep: true,
      },
      connect: {
        action: () => this.incrementStep(),
        disabled: () => !this.state.selectedInstrument,
        buttonLabel: this.intl.formatMessage({ id: 'general.next', defaultMessage: 'Next' }),
        buttonIcon: 'forward',
        isStep: true,
      },
      serial: {
        action: () => this.incrementStep(),
        disabled: () =>
          !this.state.serialNumber ||
          this.state.serialNumber.length <
            this.formValidation[this.state.selectedInstrument].serial,
        buttonLabel: this.intl.formatMessage({ id: 'general.next', defaultMessage: 'Next' }),
        buttonIcon: 'forward',
        isStep: true,
      },
      registrationCode: {
        action: () => this.registerInstrument(),
        disabled: () =>
          !this.state.registrationCode ||
          this.state.registrationCode.length <
            this.formValidation[this.state.selectedInstrument].regCode,
        loading: () => this.props.registerInstrument.busy,
        buttonLabel: this.intl.formatMessage({ id: 'general.next', defaultMessage: 'Next' }),
        buttonIcon: 'forward',
        isStep: true,
      },
      naming: {
        action: () => this.saveInstrumentName(),
        disabled: () => !this.state.instrumentName,
        buttonLabel: this.intl.formatMessage({ id: 'general.save', defaultMessage: 'Save' }),
        buttonIcon: 'done',
        isStep: false,
        optional: true,
      },
      puk: {
        action: () => this.incrementStep(),
        disabled: () => false,
        buttonLabel: this.intl.formatMessage({ id: 'general.next', defaultMessage: 'Next' }),
        buttonIcon: 'forward',
        isStep: true,
      },
      pendingInstrument: {
        action: () => this.registerInstrument(),
        disabled: () => !this.props.activeInstrument.RegCode,
        loading: () => this.props.registerInstrument.busy,
        buttonLabel: this.intl.formatMessage({ id: 'general.next', defaultMessage: 'Next' }),
        buttonIcon: 'forward',
        isStep: true,
      },
    };

    this.actAsOther = this.props.actAsOtherId ? true : false;

    this.hideRegisterInstrumentModal = this.hideRegisterInstrumentModal.bind(this);
    this.registerInstrument = this.registerInstrument.bind(this);
    this.serialNumberChanged = this.serialNumberChanged.bind(this);
    this.registrationCodeChanged = this.registrationCodeChanged.bind(this);
    this.instrumentNameChanged = this.instrumentNameChanged.bind(this);
    this.instrumentSelected = this.instrumentSelected.bind(this);
    this.getFreeSmartPegsChanged = this.getFreeSmartPegsChanged.bind(this);
    this.getData = this.getData.bind(this);
    this.updateClinicAddress = this.updateClinicAddress.bind(this);
    this.setPromotion = this.setPromotion.bind(this);
    this.incrementStep = this.incrementStep.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
  }
  componentDidMount() {
    this.resetState();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.activeInstrument.RegCode) {
      this.setState({
        serialNumber: nextProps.activeInstrument.SerialNumber,
        registrationCode: nextProps.activeInstrument.RegCode,
      });
    }

    if (nextProps.registerInstrument.instrument) {
      this.setState({
        puk: nextProps.registerInstrument.instrument.puk,
        instrumentId: nextProps.registerInstrument.instrument.id,
      });

      this.instrumentRegistered = true;
    }

    //If registerInstrument complete and IDx
    if (
      this.state.selectedInstrument === 'IDx' &&
      nextProps.registerInstrument.complete &&
      this.state.currentStepCount === 2
    ) {
      this.incrementStep();
    }

    //If registerInstrument complete and not IDx
    if (
      this.state.selectedInstrument !== 'IDx' &&
      nextProps.registerInstrument.complete &&
      this.state.currentStepList.length === this.state.currentStepCount + 2
    ) {
      this.incrementStep();
    }

    if (nextProps.downloadFirmware.complete && this.downloadingFirmware) {
      this.downloadingFirmware = false;
      this.firmwareDownloaded = true;
      this.setState({ downLoadingFirmwareType: null });
      toastr.success(
        this.intl.formatMessage({ id: 'general.success', defaultMessage: 'Success' }),
        this.intl.formatMessage({
          id: 'devices.firmwareDownloaded',
          defaultMessage: 'Firmware downloaded',
        }),
        toastrOptions
      );
    }
  }

  componentDidUpdate() {
    if (this.state.error || this.props.registerInstrument.error) {
      this.showErrorToast();
    }
  }

  resetState() {
    const state = {
      serialNumber: '',
      registrationCode: '',
      instrumentName: '',
      puk: '',
      instrumentId: '',
      getFreeSmartPegs: false,
      canProceed: true,
      selectedInstrument: undefined,
      currentStepCount: 0,
      currentRegisterStepCount: 0,
      currentStep: this.registerSteps.select,
      maxSteps: 0,
      currentStepList: [],
      error: null,
    };
    this.setState(state);
  }
  getCurrentUserId() {
    return this.props.actAsOtherId ? this.props.actAsOtherId : this.props.user.id;
  }

  hideRegisterInstrumentModal(reloadInstruments) {
    this.props.actions.clearRegisterInstrument();
    this.resetState();

    this.setState(
      {
        puk: '',
        serialNumber: '',
        registrationCode: '',
        error: null,
        getFreeSmartPegs: false,
        canProceed: true,
        selectedInstrument: undefined,
        step: 0,
      },
      () => {
        if (this.props.hide) {
          this.props.hide(reloadInstruments || this.instrumentRegistered);
          this.instrumentRegistered = false;
        }

        this.props.actions.getUser();
      }
    );

    this.order = undefined;

    if (!reloadInstruments && this.props.logoutAtCancel) {
      this.props.actions.logoutAccount();
      this.props.actions.clearToken(false, false);
      this.props.history.push('/');
    }

    // if (reloadInstruments && process.env.REACT_APP_DEMO) {
    //   this.props.actions.showVideo('https://www.youtube.com/watch?v=Y4sx5jT0HSs');
    // }
  }

  updateClinicAddress() {
    let clinic = Object.assign({}, this.props.clinic.address);
    clinic.name = this.order.clinicName;
    clinic.street = this.order.clinicAddress.street;
    clinic.careOf = this.order.clinicAddress.careOf;
    clinic.city = this.order.clinicAddress.city;
    clinic.postcode = this.order.clinicAddress.postcode;
    clinic.countryCode = this.order.clinicAddress.countryCode;
    clinic.state = this.order.clinicAddress.state;
    clinic.numberOfPractitionersInClinic = this.props.clinic.numberOfPractitionersInClinic;

    this.props.actions.updateClinic(clinic);
  }

  serialNumberChanged(evt) {
    this.setState({
      serialNumber: evt.target.value,
    });
  }

  registrationCodeChanged(evt) {
    this.setState({
      registrationCode: evt.target.value.toLowerCase(),
    });
  }
  instrumentNameChanged(evt) {
    this.setState({
      instrumentName: evt.target.value,
    });
  }
  saveInstrumentName() {
    const id = this.state.instrumentId;
    const name = this.state.instrumentName;
    this.props.actions.setInstrumentName(id, name);
    this.incrementStep();
  }
  registerInstrument() {
    if (
      this.getCurrentUserId() &&
      this.state.selectedInstrument &&
      this.state.serialNumber &&
      this.state.registrationCode
    ) {
      this.setState({
        error: null,
      });

      const instrumentType =
        this.state.selectedInstrument === 'Beacon' || this.state.selectedInstrument === 'MegaISQ'
          ? 4
          : 0;
      const instrumentVariant = this.state.selectedInstrument === 'MegaISQ' ? 1 : null;

      this.props.actions.registerInstrument(
        this.getCurrentUserId(),
        instrumentType,
        instrumentVariant,
        this.state.serialNumber,
        this.state.registrationCode,
        this.actAsOther,
        this.setPromotion
      );
    } else {
      const errorMessages = [];
      if (!this.state.selectedInstrument) {
        errorMessages.push({
          key: 'MissingInstrumentType',
          text: this.intl.formatMessage({
            id: 'registerDevice.selectInstrument',
            defaultMessage: 'Please select instrument to register',
          }),
        });
      } else if (!this.state.serialNumber) {
        errorMessages.push({
          key: 'MissingSerialNumber',
          text: this.intl.formatMessage({
            id: 'registerDevice.enterSerialNimber',
            defaultMessage: 'Please enter a serial number',
          }),
        });
      } else if (!this.state.registrationCode) {
        errorMessages.push({
          key: 'MissingRegistrationCode',
          text: this.intl.formatMessage({
            id: 'registerDevice.enterRegistrationCode',
            defaultMessage: 'Please enter a registration code',
          }),
        });
      }

      this.setState({
        error: {
          messages: errorMessages,
        },
      });
      this.showErrorToast();
    }
  }
  setPromotion(promotion) {
    this.promotion = promotion;
  }

  getFreeSmartPegsChanged() {
    let canProceed = false;
    if (this.state.getFreeSmartPegs) {
      canProceed = true;
    } else {
      if (this.order && this.order.smartPegTypes.some((smartPegType) => smartPegType !== '-1')) {
        canProceed = true;
      }
    }

    this.setState({
      getFreeSmartPegs: !this.state.getFreeSmartPegs,
      canProceed: canProceed,
    });
  }

  getData(clinicAddress, smartPegTypes) {
    this.order = {
      clinicName: clinicAddress.name,
      clinicAddress: clinicAddress,
      smartPegTypes: smartPegTypes,
    };

    this.setState({
      canProceed:
        this.state.getFreeSmartPegs &&
        this.order &&
        this.order.smartPegTypes.some((smartPegType) => smartPegType !== '-1'),
    });
  }

  instrumentSelected(type) {
    const stepList =
      type === 'IDx'
        ? this.stepList['IDx']
        : window.ReactNativeWebView
        ? this.stepList['BeaconApp']
        : this.stepList[type];
    this.setState({
      selectedInstrument: type,
      currentStepList: stepList,
      maxSteps: stepList.reduce((steps, step) => {
        this.registerSteps[step].isStep && steps++;
        return steps;
      }, 0),
    });
  }
  incrementStep(step = 1) {
    const nextStepCount = this.state.currentStepCount + step;
    const nextStepName = this.state.currentStepList[nextStepCount];
    const nextStep = this.registerSteps[nextStepName];
    const regStepCoung = nextStepCount < this.state.maxSteps ? nextStepCount : this.state.maxSteps;
    if (!nextStepName) {
      this.setState({ currentStepCount: 0, currentStep: null });
      this.hideRegisterInstrumentModal(true);
      return;
    }
    this.setState({
      currentStepCount: nextStepCount,
      currentStep: nextStep,
      currentRegisterStepCount: regStepCoung,
    });
  }
  downloadGateway(name) {
    this.downloadingFirmware = true;
    this.setState({ downLoadingFirmwareType: name });
    this.props.actions.downloadFirmware(name);
  }
  showErrorToast() {
    const error = this.state.error || this.props.registerInstrument.error;
    this.props.actions.clearRegisterInstrument();
    this.setState({ error: null });

    const toastrOptions = {
      showCloseButton: false,
      position: 'bottom-right',
      preventDuplicates: true,
      closeOnToastrClick: true,
      timeOut: 5000,
    };

    error &&
      error.messages.forEach((m) =>
        toastr.error(
          this.intl.formatMessage({ id: 'general.error', defaultMessage: 'Error' }),
          this.intl.formatMessage({ id: m.text }),
          toastrOptions
        )
      );
  }
  renderNavButtons() {
    const currentStep = this.state.currentStep;
    const hideButtonText = currentStep?.optional
      ? this.intl.formatMessage({ id: 'general.skip', defaultMessage: 'Skip' })
      : this.intl.formatMessage({ id: 'general.back', defaultMessage: 'Back' });
    return (
      <Fragment>
        {(currentStep?.isStep || currentStep?.optional) && (
          <Button
            big
            value={hideButtonText}
            onClick={() =>
              currentStep?.optional
                ? this.hideRegisterInstrumentModal(true)
                : this.incrementStep(-1)
            } //Only reload if completed the registration
          />
        )}
        {currentStep && (
          <Button
            primary
            big
            value={currentStep.buttonLabel}
            onClick={() => currentStep.action()}
            disabled={currentStep.disabled()}
            loading={currentStep.loading && currentStep.loading()}
            rightIcon={currentStep.buttonIcon}
          />
        )}
      </Fragment>
    );
  }
  renderDeviceSelection() {
    return (
      <Fragment>
        <p>
          {this.intl.formatMessage({
            id: 'registerDevice.whatModel',
            defaultMessage: 'What model would you like to add?',
          })}
        </p>
        <div className={styles.buttonWrapper}>
          <LargeButton
            secondary
            label="Osstell IDx"
            selected={this.state.selectedInstrument === 'IDx'}
            onClick={this.instrumentSelected.bind(this, 'IDx')}
          >
            <img src={idxImage} alt="" />
          </LargeButton>
          <LargeButton
            secondary
            label="Osstell Beacon"
            selected={this.state.selectedInstrument === 'Beacon'}
            onClick={this.instrumentSelected.bind(this, 'Beacon')}
          >
            <img src={beaconImage} alt="" />
          </LargeButton>
          <LargeButton
            secondary
            label="Mega ISQ II"
            selected={this.state.selectedInstrument === 'MegaISQ'}
            onClick={this.instrumentSelected.bind(this, 'MegaISQ')}
          >
            <img src={megaISQImage} alt="" />
          </LargeButton>
        </div>
      </Fragment>
    );
  }
  renderDownloadPanel() {
    return (
      <Fragment>
        <p>
          <FormattedMessage
            id="registerDevice.downloadDescription"
            defaultMessage="To use {instrument} you need to download and install the Beacon Gateway."
            values={{ instrument: this.deviceNames[this.state.selectedInstrument] }}
          />
        </p>
        <div className={`${styles.buttonWrapper} ${styles.dowloadFirmware}`}>
          <LargeButton
            secondary
            label={this.intl.formatMessage({
              id: 'registerDevice.downloadForWindows',
              defaultMessage: 'Download for Windows',
            })}
            loading={this.state.downLoadingFirmwareType === 'latestgatewaypc'}
            onClick={() => this.downloadGateway('latestgatewaypc')}
          >
            {windowsIcon}
          </LargeButton>
          <LargeButton
            secondary
            label={this.intl.formatMessage({
              id: 'registerDevice.downloadForMac',
              defaultMessage: 'Download for Mac',
            })}
            loading={this.state.downLoadingFirmwareType === 'latestgatewaymac'}
            onClick={() => this.downloadGateway('latestgatewaymac')}
          >
            {macIcon}
          </LargeButton>
        </div>
      </Fragment>
    );
  }
  renderInstallPanel() {
    return (
      <Fragment>
        <p>
          <FormattedMessage
            id="registerDevice.downloadDescriptionPostDownload"
            defaultMessage="Install the downloaded Gateway software and follow the instructions on screen"
          />
        </p>
        <div className={styles.narrow}>
          <div className={styles.illustrationWrapper}>
            <img className={styles.imageSize} src={installGateway} alt="" />
          </div>
        </div>
      </Fragment>
    );
  }
  renderConnectKey() {
    return (
      <Fragment>
        <p>
          <FormattedMessage
            id="registerDevice.insertKey"
            defaultMessage="Insert the Osstell key to a USB port on your computer"
          />
        </p>
        <div className={styles.narrow}>
          <div className={styles.illustrationWrapper}>{connectKeyIllustration}</div>
        </div>
      </Fragment>
    );
  }
  renderEnterSerial() {
    return (
      <Fragment>
        <p>
          {this.state.selectedInstrument !== 'IDx' && (
            <FormattedMessage
              id="registerDevice.enterSerialBeacon"
              defaultMessage="Fill in the serial number (6 digits). You can find it on the back of your instrument."
              values={{ instrument: this.deviceNames[this.state.selectedInstrument] }}
            />
          )}
          {this.state.selectedInstrument === 'IDx' && (
            <FormattedMessage
              id="registerDevice.enterSerialIDx"
              defaultMessage="Enter your IDx serial number. It can be found on the label on the backside of the IDx"
            />
          )}
        </p>
        <div className={styles.narrow}>
          <div className={styles.illustrationWrapper}>
            {this.state.selectedInstrument !== 'IDx' && (
              <img src={beaconSerialNumber} alt="beaconSerial" />
            )}
            {this.state.selectedInstrument === 'IDx' && (
              <img src={idxSerialNumber} alt="idxSerial" />
            )}
          </div>
          <InputRow>
            <InputItem
              type="text"
              placeholder={this.intl.formatMessage({
                id: 'registerDevice.serialPlaceholder',
                defaultMessage: 'Enter serial number',
              })}
              onChange={this.serialNumberChanged}
              value={this.state.serialNumber}
              dark
            />
          </InputRow>
        </div>
      </Fragment>
    );
  }
  renderRegistrationCode() {
    return (
      <Fragment>
        <p>
          {this.state.selectedInstrument !== 'IDx' && (
            <FormattedMessage
              id="registerDevice.enterRegistrationCodeBeacon"
              defaultMessage="Fill in the registration code. You can find it in the lower display on your instrument."
              values={{ instrument: this.deviceNames[this.state.selectedInstrument] }}
            />
          )}
          {this.state.selectedInstrument === 'IDx' && (
            <FormattedMessage
              id="registerDevice.enterRegistrationCodeIdx"
              defaultMessage="Enter the registration code that can be seen on the IDx screen"
            />
          )}
        </p>

        {this.state.selectedInstrument !== 'IDx' && (
          <div className={styles.illustrationWrapper}>
            <video muted autoPlay loop playsInline>
              <source ref={this.vidRef} src={beaconCode} type="video/mp4" />
            </video>
          </div>
        )}

        {this.state.selectedInstrument === 'IDx' && (
          <div className={styles.narrow}>
            <div className={styles.illustrationWrapper}>
              <img src={idxCode} alt="IDxCode" />
            </div>
          </div>
        )}

        <div className={styles.narrow}>
          <InputRow>
            <InputItem
              type="text"
              placeholder={this.intl.formatMessage({
                id: 'registerDevice.registrationCodePlaceholder',
                defaultMessage: 'Enter registration code',
              })}
              onChange={this.registrationCodeChanged}
              value={this.state.registrationCode}
              dark
            />
          </InputRow>
        </div>
        {this.state.selectedInstrument !== 'IDx' && (
          <div className={styles.note}>
            <p>
              <FormattedMessage
                id="registerDevice.enterRegistrationCodeNote"
                defaultMessage="Note that this procedure might take a few seconds, as your instrument is establishing a connection to the gateway."
              />
              <br />
              <FormattedMessage
                id="registerDevice.enterRegistrationCodeWhenConnected"
                defaultMessage="When connected the animation of the {icon} symbol will stop and be fully shown."
                values={{
                  icon: connectionSymbol,
                }}
              />
            </p>
          </div>
        )}
      </Fragment>
    );
  }
  renderNameDevice() {
    return (
      <Fragment>
        <ChangeDeviceName
          instrumentNameChanged={this.instrumentNameChanged}
          instrumentName={this.state.instrumentName}
          selectedInstrumentType={this.state.selectedInstrument}
        />
      </Fragment>
    );
  }
  renderPUK() {
    return (
      <Fragment>
        <p>
          <FormattedMessage id="registerDevice.PUKdescription" defaultMessage="Puk description" />
        </p>
        <div className={styles.narrow}>
          <div className={cn(styles.pukWrapper, styles.showPuk)}>
            <div>
              <p>
                {this.intl.formatMessage({
                  id: 'registerDevice.enterPUK',
                  defaultMessage: 'Enter this PUK code on your IDx',
                })}
              </p>
              <div className={styles.illustrationWrapper}>
                <p className={styles.puk}>{this.state.puk}</p>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
  renderPendingInstrumet() {
    return this.props.activeInstrument.Active && this.props.activeInstrument.RegCode ? (
      <Fragment>
        <p>
          <FormattedMessage
            id="registerDevice.registerConnectedInstrument"
            defaultMessage="Do you want to register the connected instrument: "
          />
        </p>
        <p>
          <FormattedMessage id="registerDevice.serialNumber" defaultMessage="Serial Number: " />
          <strong>#{this.props.activeInstrument.SerialNumber}</strong>
        </p>
      </Fragment>
    ) : (
      <Fragment>
        <p>
          <FormattedMessage
            id="registerDevice.startBeacon"
            defaultMessage="Start the instrument and let it connect to the App."
          />
        </p>

        <div className={styles.illustrationWrapper}>
          <video muted autoPlay loop playsInline>
            <source ref={this.vidRef} src={beaconCode} type="video/mp4" />
          </video>
        </div>
        <div className={styles.note}>
          <p>
            <FormattedMessage
              id="registerDevice.pendingInstrumentNote"
              defaultMessage="Please make sure you have granted the app access to Bluetooth."
            />
          </p>
        </div>
      </Fragment>
    );
  }

  onDismiss() {
    if (this.props.logoutAtCancel && !this.state.currentStep?.optional) {
      const content = (
        <div>
          <p>
            {this.intl.formatMessage({
              id: 'registerDevice.ondissmissText',
              defaultMessage:
                'You need to register an instrument in order to use OsstellConnect. If you choose to abort you can login with your created credentials later and finalize the registration.',
            })}
          </p>
        </div>
      );
      this.props.actions.showConfirmation(
        this.intl.formatMessage({
          id: 'registerDevice.abortRegistration',
          defaultMessage: 'Abort Registration',
        }),
        content,
        this.hideRegisterInstrumentModal
      );
      return;
    }

    this.hideRegisterInstrumentModal(true);
  }

  render() {
    return (
      <Modal
        fullModal={this.props.fullModal}
        header={this.intl.formatMessage({
          id: 'registerDevice.registerInstrument',
          defaultMessage: 'Register Instrument',
        })}
        onDismiss={this.onDismiss}
        show={this.props.show}
        modalPanelClass={styles.modal}
        modalContentClass={styles.content}
      >
        <div className={styles.modalInner}>
          <div className={styles.mainWrapper}>
            {this.state.currentStepCount > 0 && (
              <div className={styles.stepNav}>
                <Button
                  leftIcon="back"
                  white
                  big
                  noShadow
                  iconButton
                  primary
                  onClick={() => this.incrementStep(-1)}
                />
                <FormattedMessage id="registerDevice.step" defaultMessage="Step" />{' '}
                {this.state.currentRegisterStepCount} / {this.state.maxSteps}
              </div>
            )}
            {this.state.currentStep === this.registerSteps.select && this.renderDeviceSelection()}
            {this.state.currentStep === this.registerSteps.download && this.renderDownloadPanel()}
            {this.state.currentStep === this.registerSteps.install && this.renderInstallPanel()}
            {this.state.currentStep === this.registerSteps.connect && this.renderConnectKey()}
            {this.state.currentStep === this.registerSteps.serial && this.renderEnterSerial()}
            {this.state.currentStep === this.registerSteps.registrationCode &&
              this.renderRegistrationCode()}
            {this.state.currentStep === this.registerSteps.naming && this.renderNameDevice()}
            {this.state.currentStep === this.registerSteps.puk && this.renderPUK()}
            {this.state.currentStep === this.registerSteps.pendingInstrument &&
              this.renderPendingInstrumet()}
          </div>
          <div className={styles.footer}>{this.renderNavButtons()}</div>
        </div>
      </Modal>
    );
  }
}

function mapState(state) {
  return {
    locale: state.translation.locale,
    user: state.user.user,
    registerInstrument: state.instrument.registerInstrument,
    clinic: state.clinic.clinic,
    downloadFirmware: state.firmware.downloadFirmware,
    activeInstrument: state.instrument.activeInstrument,
  };
}

function mapDispatch(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...instrumentActions,
        ...clinicActions,
        ...promotionActions,
        ...userActions,
        ...generalActions,
        ...firmwareActions,
        ...accountActions,
      },
      dispatch
    ),
  };
}

export default withRouter(connect(mapState, mapDispatch)(injectIntl(RegisterInstrumentModal)));
